import { render, staticRenderFns } from "./WarehouseAddressSection.vue?vue&type=template&id=a88cd1d8"
import script from "./WarehouseAddressSection.vue?vue&type=script&lang=js"
export * from "./WarehouseAddressSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports